<div class="edit-container">
    <h1 class="edit-title">Actualizare modul locații active</h1>
    <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Locație</mat-label>
                    <mat-select formControlName="id_locatie">
                        <mat-option value="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let locatie of locatii" [value]="locatie.id">
                            {{ locatie.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_locatie'].valid && form.controls['id_locatie'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Serviciu</mat-label>
                    <mat-select formControlName="id_serviciu">
                        <mat-option value="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let serviciu of servicii" [value]="serviciu.id">
                            {{ serviciu.web_name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_serviciu'].valid && form.controls['id_serviciu'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>